import { useFormat } from '@ideavivat/vivat-2';

export default {
  types: {
    _primaryControls: {
      width: '4rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
    },
    name: {
      name: 'ชื่อพนักงาน',
      width: '2fr',
    },
    employeeCode: {
      name: 'รหัสผู้ใช้',
      width: '8rem',
    },
    // eslint-disable-next-line
    last_login: {
      name: 'เข้าใช้งานล่าสุด',
      width: '12rem',
      class: 'text-right',
      filter(val: any) {
        if (!val) return '';
        return useFormat.date(val).displayShortThaiDateTime();
      },
    },
    _activeControls: {
      width: '3rem',
    },
  },
};
